import Range from './Range.vue'

export default Range
